export const MIN_QTY = 1;
export const MAX_QTY = 9999;
